import React from "react";
import {  Col, Form, Modal, Row } from "react-bootstrap";
import Fontstyling from "../../../../components/common/comman";
import { useState } from "react";
import { useRef } from "react";
import { useEffect } from "react";
import * as Yup from "yup";
import { Formik } from "formik";
import {
  GetCociDetails,
  AddCoci,
  DeleteCoci,
  UpdateCoci,
} from "../../../../api/User/ACG/COCIApi";
import CustomButton from "../../../../components/common/CustomButton";
import DeleteModal from "../../../../components/common/Modal/DeleteModal";
import CustomMaterialTable from "../../../../components/common/CustomMaterialTable";
import toastFile from "../../../../Service/ToastFile";
import CustomInputField from "../../../../components/common/CustomInputField";

const schema = Yup.object().shape({
  medical_Inflation: Yup.number()
    .typeError("Please enter a valid number")
    .required("Please enter COCI Inflation"),
});

const COCI = () => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState(null);
  const [isGetData, setIsGetData] = useState(false);
  const [witchAction, setWitchAction] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [isDataChanged, setIsDataChanged] = useState("");
  const [importedFile, setImportedFile] = useState(null);
  const [isRender, setIsRender] = useState(false);
  const buttonRef = useRef(null);
  const fileInputRef = useRef(null);
  const column = [
    {
      title: "COCI",
      field: "medical_Inflation",
      render: (rowData) => (+rowData.medical_Inflation * 100).toFixed(2) + "%",
      customFilterAndSearch: (query, rowData) => {
        const searchText = query.toLowerCase();
        const processedData = (+rowData.medical_Inflation * 100).toFixed(2) + "%";
        return processedData.toLowerCase().includes(searchText);
      },
    },
  ];
  useEffect(() => {
    if (showModal === false) {
      setSelectedRowData(null);
    }
    if (isGetData) {
      getCociDetailsData();
    }
    setIsGetData(false);
  }, [showModal]);

  useEffect(() => {
    getCociDetailsData();
  }, []);

  const getCociDetailsData = () => {
    setIsLoading(true);
    GetCociDetails()
      .then((res) => {
        if(res.status === 200 || res.status === 204){
        setData(res.data);
        }
      })
      .catch((err) => console.log({ err }))
      .finally((res) => setIsLoading(false));
  };

  const handleActions = (values) => {
    buttonRef.current.disabled = true;

    const { medical_Inflation } = values;
    const payload = {
      id: 0,
      medical_Inflation: +medical_Inflation,
    };

    if (witchAction === "add") {
      AddCoci(payload).then((res) => {
        if(res.status === 200 || res.status === 204){
        setIsGetData(true)
        toastFile("new");
        setShowModal(false);
        setIsRender(!isRender);
        }
      });
    } else if (witchAction === "update") {
      UpdateCoci(selectedRowData.id, {
        ...payload,
        id: selectedRowData.id,
      }).then((res) => {
        if(res.status === 200 || res.status === 204){
        setIsGetData(true)
        toastFile("update");
        setShowModal(false);
        setIsRender(!isRender);
        }
      });
    }
  };

  return (
    <div>
      <Modal
        show={showModal}
        aria-labelledby="contained-modal-title-vcenter"
        centered={witchAction !== "delete"}
      >
        <Modal.Header closeButton onHide={() => setShowModal(false)}>
          <Modal.Title
            id="contained-modal-title-vcenter"
            style={Fontstyling.modalHeading}
          >
            {witchAction === "add"
              ? "Add "
              : witchAction === "update"
              ? "Update "
              : "Delete "}
            COCI Inflation
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {witchAction === "delete" ? (
            <DeleteModal
              onClickYes={() => {
                DeleteCoci(selectedRowData?.id).then((res) => {
                  if(res.status === 200 || res.status === 204){
                  toastFile("delete");
                  setIsGetData(true);
                  setShowModal(false);
                  }
                });
              }}
              onClickNo={() => setShowModal(false)}
            />
          ) : (
            <Formik
              validationSchema={schema}
              onSubmit={handleActions}
              initialValues={{
                medical_Inflation: selectedRowData
                  ? selectedRowData.medical_Inflation
                  : 0,
              }}
            >
              {({
                handleSubmit,
                handleChange,
                handleBlur,
                values,
                touched,
                isValid,
                errors,
              }) => (
                <Form onSubmit={handleSubmit}>
                  {witchAction === "delete" ? (
                    <DeleteModal
                      onClickYes={() => {
                        DeleteCoci(selectedRowData?.id).then((res) => {
                          if(res.status === 200 || res.status === 204){
                          setIsDataChanged("delete");
                          setShowModal(false);
                          }
                        });
                      }}
                      onClickNo={() => setShowModal(false)}
                    />
                  ) : (
                    <>
                      <Row className="mb-2 gap-3">
                        <Col>
                          <CustomInputField
                            label="COCI"
                            name="medical_Inflation"
                            maxLength={10}
                            value={values}
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            touched={touched}
                            errors={errors}
                            isRequired
                          />
                        </Col>
                      </Row>
                    </>
                  )}
                  <div className="d-flex align-items-center justify-content-end gap-3 my-4">
                    <button
                      ref={buttonRef}
                      style={Fontstyling.savebutton}
                      type="submit"
                    >
                      save
                    </button>
                    <button
                      style={Fontstyling.cancelbutton}
                      type="reset"
                      onClick={() => setShowModal(false)}
                    >
                      Cancel
                    </button>
                  </div>
                  <span className="text-success" style={{fontSize:"12px"}}>
                    * No special characters are allowed
                  </span>
                </Form>
              )}
            </Formik>
          )}
        </Modal.Body>
      </Modal>
      {/* <div className="text-end py-3 border-bottom">
        <CustomButton
          onClick={() => {
            setWitchAction("add");
            setShowModal(true);
          }}
        >
          Add COCI Inflation
        </CustomButton>
      </div> */}
      <CustomMaterialTable
        isDelete={false}
        column={column}
        data={data}
        selectedRow={selectedRow}
        setSelectedRow={setSelectedRow}
        setWitchAction={setWitchAction}
        setSelectedRowData={setSelectedRowData}
        setShowModal={setShowModal}
        isLoading={isLoading}
      />
    </div>
  );
};

export default COCI;
